import React from 'react';
import lightHouseImage from "../img/envision/valuefirst/cards/image (2).png";





const BookletValueFirst = () => {
    return (
        <div className="booklet-container" style={{background:"#fff"}}>
            <div className="booklet-content">
                <div className="booklet-left">
                    <img
                         src={lightHouseImage}
                        alt="booklet"
                        className="booklet-image"
                        loading="lazy"
                    />
                </div>

                <div className="booklet-right">
                    <div className="text-content">
                        <h3>
                            The ValuesFIRST Navigator celebrates the 'Drebconists' that are living
                            these values every day.
                        </h3>
                        <a
                            href="#"
                            rel="noopener noreferrer"
                            className="download-btn"
                        >
                            Download
                        </a>
                    </div>
                </div>
            </div>
            <style jsx="true">{`
        .booklet-container {
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 50px;
        }

        .booklet-content {
          display: flex;
          align-items: center;
          gap: 0px; /* Remove the gap between the elements */
          border: 1px solid #e0e0e0;
          padding: 30px;
          border-radius: 10px; /* Outer border-radius */
          background-color: white;
          position: relative;
        }

        .booklet-left {
          flex: 1;
          margin-right: -30px; /* Negative margin to pull the image closer to the content */
        }

        .booklet-right {
          flex: 1;
          border-radius: 10px; /* Added border-radius to booklet-right */
          overflow: hidden; /* Ensures content fits inside the rounded corners */
          position: relative;
          z-index: 1; /* Make sure content is above image if overlapping */
        }

        .text-content {
          display: flex;
          flex-direction: column;
          justify-content: center;
          border-radius: 10px; /* Applied border-radius to text content */
          padding: 20px;
          background-color: #f9f9f9; /* Added background color to text content */
          z-index: 2; /* Make sure content stays on top */
        }

        .booklet-image {
          width: 100%;
          max-width: 400px;
          height: auto;
          border-radius: 10px; /* Applied border-radius to the image */
        }

        .text-content h3 {
          font-size: 20px;
          font-weight: 500;
          color: #008f8c;
          margin-bottom: 20px;
        }

         .download-btn {
    padding: 8px 16px; /* Decrease padding to make the button smaller */
    background-color: #00a0a0;
    color: white;
    text-decoration: none;
    border-radius: 6px;
    font-weight: bold;
    display: inline-block;
    text-align: center; /* Ensure text inside the button is centered */
    width: auto; /* Allow width to be determined by the content */
    max-width: 150px; /* Limit the width */
    margin: 0 auto; /* Center the button horizontally */
  }

  .download-btn:hover {
    background-color: #007c7b;
  }
      `}</style>
        </div>
    );
};

export default BookletValueFirst;
